/*
 * Clients and Tags strings, verbatim from docs/spec/modules/clients-tags.md and the live notes (clients.md, tags.md).
 * Wording marked unverified in the spec is kept as the spec gives it.
 */
export const s = {
  clientsTitle: "Clients",
  tagsTitle: "Tags",
  showActive: "Show active",
  showArchived: "Show archived",
  showAll: "Show all",
  searchByName: "Search by name",
  addNewClient: (label: string) => `Add new ${label}`,
  addNewTag: "Add new tag",
  add: "ADD",
  colName: "Name",
  colAddress: "Address",
  colCurrency: "Currency",
  edit: "Edit",
  more: "More actions",
  note: "Note",
  archive: "Archive",
  restore: "Restore",
  delete: "Delete",
  cancel: "Cancel",
  save: "Save",
  selectRow: (name: string) => `Select ${name}`,
  selectAll: "Select all",
  selected: (n: number) => `${n} selected`,
  statusFilter: "Status filter",

  clientCreated: (name: string) => `Client ${name} has been created`,
  clientUpdated: "Client has been updated",
  clientArchived: "Client successfully archived",
  clientsArchived: "Clients successfully archived",
  clientRestored: "Client successfully restored",
  clientsRestored: "Clients successfully restored",
  clientDeleted: "Client successfully deleted",
  clientsDeleted: "Clients successfully deleted",
  tagCreated: (name: string) => `Tag ${name} has been created`,
  tagUpdated: "Tag has been updated",
  tagArchived: "Tag successfully archived",
  tagsArchived: "Tags successfully archived",
  tagRestored: "Tag successfully restored",
  tagsRestored: "Tags successfully restored",
  tagDeleted: "Tag successfully deleted",
  tagsDeleted: "Tags successfully deleted",

  editClient: "Edit Client",
  editTag: "Edit tag",
  fieldName: "Name",
  fieldEmail: "Email",
  emailPlaceholder: "Enter email",
  fieldCc: "Cc recipients (3 maximum)",
  ccInfo: "Additional email addresses that will receive invoices",
  ccPlaceholder: "Enter one or more email addresses",
  removeCc: (email: string) => `Remove ${email}`,
  fieldAddress: "Address",
  addressPlaceholder: "Enter address",
  fieldNote: "Note",
  notePlaceholder: "Enter note",
  fieldCurrency: "Currency",
  findCurrencies: "Find currencies...",
  noCurrencies: "No matching currencies",
  currencyHint: "Add currencies in Workspace settings > Finances",
  emailInvalid: "Email format is not valid",
  nameRequired: (entity: string) => `${entity} name must be between 1 and 100 characters`,
  ccMaxReached: "You can add up to 3 email addresses",

  archiveTitle: (name: string) => `Archive ${name}`,
  archiveManyTitle: (n: number, plural: string) => `Archive ${n} ${plural}`,
  archiveBody: (name: string) => `${name} won't be available when tracking time`,
  archiveManyBody: (n: number, plural: string) => `${n} ${plural} won't be available when tracking time`,
  archiveProjects: (label: string) => `Also archive all Projects assigned to this ${label}`,
  markTasksDone: "Also mark all Tasks as done",
  archiveCta: "Archive",
  restoreTitle: (name: string) => `Restore ${name}`,
  restoreManyTitle: (n: number, plural: string) => `Restore ${n} ${plural}`,
  restoreBody: (name: string) => `${name} will be available again.`,
  restoreCta: "Restore",
  deleteTitle: "Delete",
  deleteQuestion: (name: string) => `Are you sure you want to delete ${name}?`,
  deleteManyQuestion: (n: number, plural: string) => `Are you sure you want to delete ${n} ${plural}?`,
  deleteBody: (name: string) =>
    `${name} will also be removed from all time entries they are assigned to. This action cannot be reversed.`,
  deleteManyBody:
    "They will also be removed from all time entries they are assigned to. This action cannot be reversed.",
  typeDelete: "Type DELETE to confirm",
  deleteWord: "DELETE",
  deleteCta: "Delete",

  // Pickers (spec 5.1, 5.2)
  selectClient: (label: string) => `Select ${label.toLowerCase()}`,
  noClient: (label: string) => `No ${label.toLowerCase()}`,
  searchClient: (label: string) => `Search ${label.toLowerCase()}`,
  noMatchingClient: (label: string) => `No matching ${label.toLowerCase()}`,
  pressCtrlEnter: "Press Ctrl+Enter to quickly",
  createClientLink: (typed: string, label: string) => `create '${typed}' ${label.toLowerCase()}`,
  tagsPicker: "Tags",
  addSearchTags: "Add/Search tags",
  noMatchingTag: "No matching tag",
  createTagLink: (typed: string) => `create '${typed}' tag`,
  tagRequired: "Tag is required",
  withoutClient: (label: string) => `Without ${label.toLowerCase()}`,
  clientFilter: (label: string) => label,
  searchClients: (plural: string) => `Search ${plural.toLowerCase()}`,
} as const;

/** "Client" -> "Clients" (spec 2: Clockify pluralises the custom label by appending "s"). */
export const plural = (label: string) => `${label}s`;
